import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import { FontField as EditComponent } from '../tsx/FontField';

import { Dispatcher as FontsDispatcher } from './fonts/Dispatcher';
import { Actions as FontsActions } from './fonts/Actions';
import { Store as FontsStore } from './fonts/Store';

export class FontField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    constructor(glob, title: string, validators?: any, defaultVal = {}, options?) {
        super(glob, title, FontField.defaultValidators, validators, defaultVal, options);

        if (glob.FontsDispatcher == null) {
            glob.FontsDispatcher = FontsDispatcher.get();
        }

        if (glob.FontsActions == null) {
            glob.FontsActions = FontsActions.get(glob.FontsDispatcher);
        }

        if (glob.FontsStore == null) {
            glob.FontsStore = FontsStore.get(glob, glob.FontsDispatcher, glob.FontsActions);
        }
    }
}
